import { BlindWatermark } from 'watermark-js-plus'
import type { WatermarkOptions } from 'watermark-js-plus'

// 水印
export function useWatermark() {
  const watermark = ref<BlindWatermark>()

  function createWatermark() {
    // BlindWatermark
    watermark.value = new BlindWatermark({
      width: 200,
      height: 150,
      rotate: 0,
      fontColor: '#ffffff',
      fontSize: '36px',
      fontFamily: 'Helvetica, Arial, Bebas Neue, sans-serif',
      contentType: 'multi-line-text',
      globalAlpha: 0.01,
    })
  }

  /** 更新水印 */
  async function updateWatermark(params: Partial<WatermarkOptions>) {
    if (!watermark.value) {
      createWatermark()
      await nextTick()
    }

    return watermark.value!.changeOptions(params, 'append')
  }

  onBeforeUnmount(() => {
    watermark.value?.destroy()
  })

  return { updateWatermark, watermark }
}
